export default __webpack_public_path__ + "static/light_bulb_b.89d5998b7cf82e3679a674f295fe414e.svg";